module.exports = __webpack_public_path__ + "img/flipkart_grocery.5a4dff2a.svg";